module.exports = ".banner-sidebar-wrap{\r\n    margin-left: 0!important;\r\n    margin-right: 0!important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/banner/banner-sidebar/banner-sidebar.component.css
// module id = ./src/app/core/banner/banner-sidebar/banner-sidebar.component.css
// module chunks = dashboard.module